import React, { FC } from 'react';
import { STagContainer, TagVariant } from './styles';

interface TagProps {
    color?: string;
    variant?: TagVariant;
    title?: string;
    children?: React.ReactNode;
}

const Tag: FC<TagProps> = ({ color, variant = 'filled', title, children }) => (
    <STagContainer $color={color} $variant={variant} title={title}>
        {children}
    </STagContainer>
);

export default Tag;
